<template>
      <div class="profile d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="listing-navbar bg-primary d-flex align-items-center gap-3 shadow-sm mb-auto p-3">
            <a @click="goBack()"><i class="bi bi-arrow-left text-white fs-5"></i></a>
            <a href="#" class="text-white" data-bs-toggle="modal" data-bs-target="#categories">
               <div class="d-flex align-items-center gap-2">
                  <!-- <img src="img/delivery-boy.jpg" alt="" class="rounded-pill img-fluid"> -->
                  <div>
                     <h6 class="fw-bold text-white mb-0"><i class="bi bi-person-lines-fill"></i> Profile</h6>
                  </div>
               </div>
            </a>
            <div class="d-flex align-items-center gap-2 ms-auto">
               <!-- <a class="toggle hc-nav-trigger hc-nav-1" href="#" role="button" aria-controls="hc-nav-1">
               <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
               <i class="bi bi-list d-flex m-0 h4 text-white"></i>
               </b>
               </a> -->
            </div>
         </div>
         <!-- body -->
         <div class="vh-100 my-auto overflow-auto p-3">
            <div class="mb-4 rounded-3 shadow-sm overflow-hidden">
               <div   @click="editUser()"   class="bg-white border-bottom p-3">
                  <div class="d-flex gap-3 align-items-center">
                     <i class="bi bi-pencil fs-5 text-muted"></i>
                     <span>
                        <p class="m-0 small text-muted">My Account</p>
                        <p class="m-0">{{profiledetails.name}}, {{profiledetails.mobile}}</p>
                     </span>
                     <a href="#" class="text-primary ms-auto d-flex"><i class="bi bi-chevron-right fs-6"></i></a>
                  </div>
               </div>

               
               <div   @click="editLaundry()" v-if="profiledetails.role == 'Admin'" class="bg-white border-bottom p-3">
                  <div class="d-flex gap-3 align-items-center">
                     <i class="bi bi-building-fill-up fs-5 text-muted"></i>
                     <span>
                        <p class="m-0 small text-muted">Laundry Details</p>
                        <p class="m-0">{{laundrydetails.name}}</p>

                     </span>
                     <a href="#" class="text-primary ms-auto d-flex"><i class="bi bi-chevron-right fs-6"></i></a>
                  </div>
               </div>
               
            </div>
           
            <!-- logout -->
            <a @click="logout" class="link-dark">
               <div class="bg-primary d-flex align-items-center rounded-3 shadow-sm justify-content-between p-3">
                  <h6 class="fw-bold text-white text-uppercase m-0" >Logout Options</h6>
                  <i class="icofont-rounded-right text-white h6 m-0"></i>
               </div>
            </a>
            <p class="pt-3 text-muted text-center small mb-0">App version 4.5.1</p>
         </div>
      </div>
      <!-- Edit Account offcanvas -->
      <div class="offcanvas offcanvas-end bg-white border-0" tabindex="-1" id="editaccount" aria-labelledby="editaccountLabel">
         <div class="offcanvas-header bg-primary shadow-sm d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left text-white fs-5"></i></a>
            <h6 class="offcanvas-title text-uppercase text-white fw-bold" id="editaccountLabel">Edit Account</h6>
         </div>
         <div class="offcanvas-body">
            <form>
             
               <div class="mb-4">
                  <label for="phone" class="form-label text-uppercase text-muted small mb-0">Phone
                  Number</label>
                  <input type="number" readonly="" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                     id="mobile" placeholder="number" v-model="profile.mobile">
               </div>
               <div class="mb-1">
                  <label for="password" class="form-label text-uppercase text-muted small mb-0">Password</label>
                  <input type="password" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                     id="password" placeholder="password" v-model="profile.password">
               </div>
                <div class="mb-1">
                  <label for="password" class="form-label text-uppercase text-muted small mb-0">Select Language</label>
                  <select id="language" v-model="profile.language"  class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2" >
                          <option value="English">English</option>
                          <option value="Marathi">Marathi</option>
                      </select> 
               </div>
               

                        <div class="mb-1">
                  <label for="password" class="form-label text-uppercase text-muted small mb-0">Allow Rate Edit</label>
                  <select id="language" v-model="profile.allow_rate_edit"  class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2" >
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                      </select> 
               </div>

                        <div class="mb-1">
                  <label for="password" class="form-label text-uppercase text-muted small mb-0">Customer Duplication</label>
                  <select id="language" v-model="profile.customer_duplication"  class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2" >
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                      </select> 
               </div>

                          <div class="mb-1">
                  <label for="password" class="form-label text-uppercase text-muted small mb-0">Partial Devlivary</label>
                  <select id="language" v-model="profile.partial_delivary"  class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2" >
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                      </select> 
               </div>

                     <div class="mb-1">
                  <label for="password" class="form-label text-uppercase text-muted small mb-0">Product Image</label>
                  <select id="language" v-model="profile.image_upload"  class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2" >
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                      </select> 
               </div>

                 <div class="mb-4">
                  <label for="phone" class="form-label text-uppercase text-muted small mb-0">Express Charges</label>
                  <input type="number" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                     id="mobile" placeholder="Express Charges In (x)" v-model="profile.express_charges">
               </div>


 


            </form>
         </div>
         <div class="offcanvas-footer shadow-sm d-flex gap-3">
            <a href="#" class="btn bg-white shadow-sm border btn-light text-primary w-100 text-uppercase btn-lg fw-bold col" data-bs-dismiss="offcanvas" aria-label="Close">Cancel</a>
            <button 
               class="btn btn-primary w-100 text-uppercase btn-lg fw-bold col rounded-3" 
               @click="updateprofile" 
               data-bs-dismiss="offcanvas" 
               aria-label="Close">
               Change
               </button>
         </div>
      </div>
      <!-- location offcanvas -->
      <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="location" aria-labelledby="locationLabel">
         <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close">
            <i class="bi bi-arrow-left fs-5 text-white"></i>
            </a>
            <h6 class="offcanvas-title text-white m-0" id="locationLabel">Update Laundry Details</h6>
         </div>
         <div class="offcanvas-body">
      



              <!-- laundry details -->
              <div v-if="laundrydetails">
               <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">Laundry Name</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="name" v-model="laundry.name">
             </div>
 
             <div class="mb-1">
                <label for="address" class="form-label text-uppercase text-muted small mb-0"> Laundry Address</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="address" placeholder="address" v-model="laundry.address">
             </div>
 
             <div class="mb-1">
                <label for="contact" class="form-label text-uppercase text-muted small mb-0">Laundry Contact</label>
                <input type="number" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="contact" placeholder="contact" v-model="laundry.contact">
             </div>
 
             <div class="mb-1">
               <label for="footermessage" class="form-label text-uppercase text-muted small mb-0">Warning Message</label>
               <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                  id="text" placeholder="message" v-model="laundry.footermessage">
            </div>

                                 <div class="mb-1">
               <label for="footermessage" class="form-label text-uppercase text-muted small mb-0">Delivery Message</label>
               <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                  id="text" placeholder="message" v-model="laundry.delv_message">
            </div>
 
             <div class="mb-1">
                <label  class="form-label" for="img_upload_here">Image<br>
                <input type="file" id="img_upload_here" style="display: none;" @change="eventFileUpload" class="form-control" required>
                 <img src="../assets/upload_image.jpg" style="height: 50px; "/><br>
                 <img v-if="!imagePreview" :src="$asset_path+'addlaundry/' +laundrydetails.img" alt="Order Image" height="150px">
                <img v-if="imagePreview" :src="imagePreview" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
                </label>
            </div>
         </div>



            <div class="offcanvas-footer shadow-sm d-flex gap-3">
               <a href="#" class="btn bg-white shadow-sm border btn-light text-primary w-100 text-uppercase btn-lg fw-bold col" data-bs-dismiss="offcanvas" aria-label="Close">Cancel</a>
               <button 
                  class="btn btn-primary w-100 text-uppercase btn-lg fw-bold col rounded-3" 
                  @click="updatelaundry" 
                  data-bs-dismiss="offcanvas" 
                  aria-label="Close">
                  Change
                  </button>
               </div>

               



         </div>
      </div>
      <!-- offcanvas help -->
      <div class="offcanvas offcanvas-end bg-light border-0" tabindex="-1" id="help" aria-labelledby="helpLabel">
         <div class="offcanvas-header bg-primary shadow-sm d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
               class="bi bi-arrow-left text-white fs-5"></i></a>
            <h6 class="offcanvas-title text-uppercase text-white fw-bold" id="helpLabel">Help & Support</h6>
         </div>
         <div class="offcanvas-body p-0">
            <div class="bg-white my-3 shadow-sm">
               <div class="accordion accordion-flush" id="accordionFlushExample">
                  <div class="accordion-item">
                     <h2 class="accordion-header p-3" id="flush-headingOne">
                        <button class="accordion-button collapsed bg-white shadow-none text-dark p-0 h6 mb-0" type="button"
                           data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                           aria-controls="flush-collapseOne">
                        Where is my Order
                        </button>
                     </h2>
                     <div id="flush-collapseOne" class="accordion-collapse collapse p-0"
                        aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body p-3 pt-0">
                           <p class="text-muted">You can track the status of your order on the order tracking
                              page.
                           </p>
                           <div class="w-50">
                              <a href="#" class="btn btn-primary w-100 py-2">Chat with us</a>
                              <p class="text-primary text-start small pt-2 m-0">Wait time under 2 min(s)</p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="border-bottom p-3">
                     <h6 class="m-0">I want to modify the items in my order</h6>
                  </div>
                  <div class="border-bottom p-3">
                     <h6 class="m-0">I want to give delivery related instructions</h6>
                  </div>
                  <div class="accordion-item">
                     <h2 class="accordion-header p-3" id="flush-headingFour">
                        <button class="accordion-button collapsed bg-white shadow-none text-dark p-0 h6 mb-0" type="button"
                           data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false"
                           aria-controls="flush-collapseFour">
                        I want to cancel my order
                        </button>
                     </h2>
                     <div id="flush-collapseFour" class="accordion-collapse collapse p-0"
                        aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body p-3 pt-0">
                           <p class="text-muted">We recommend you to cancel your order before pickup. For more
                              queries:
                           </p>
                           <div class="w-50">
                              <a href="#" class="btn btn-primary text-uppercase w-100 py-2">Chat with us</a>
                              <p class="text-primary text-start small pt-2 m-0">Wait time under 2 min(s)</p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="p-3">
                     <h6 class="m-0">I have payment and refund related issues</h6>
                  </div>
               </div>
            </div>
         </div>
      </div>
      
   </template>
   <script> 
      import axios from "@/plugins/axios";  
      
      export default {
        name: 'Branch',
        components: { 
        },
        mounted() { 
         //  this.fetchWeather();
          this.getProfile(); // Call the method here
          
      },
        data() {
          return { 
            laundrydetails:[],
            loading:false,
            error:null,
            isUserLogged:false,
            profiledetails:[], 
            imagePreview: null,   

            profile:{
                   id:'',
                   mobile:'',
                   password:'',
                   express_charges:'',
            },
           // id ko alag se pass karna

            laundry:{
               id:'',
               name:'',
               address:'',
               contact:'',
               footermessage:'',
               delv_message:''
            }
        
        
         }
        },
        methods:{
          initializeHomeContent(){
          
      
          },

          eventFileUpload(event) {
                this.laundry.img = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.laundry.file = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },


          goBack() {
                
                this.$router.go(-1);
        },
        logout() {
         
         localStorage.removeItem("token"); 
         this.$router.replace('/');
         window.location.replace("/");
        },
   
      
        editUser(){
            this.profile.id=this.profiledetails.id;
            this.profile.mobile=this.profiledetails.mobile;
            this.profile.password=this.profiledetails.password;
            this.profile.language=this.profiledetails.language;
             this.profile.allow_rate_edit=this.profiledetails.allow_rate_edit;
              this.profile.customer_duplication=this.profiledetails.customer_duplication;
               this.profile.partial_delivary=this.profiledetails.partial_delivary;
                this.profile.express_charges=this.profiledetails.express_charges;
                this.profile.image_upload=this.profiledetails.image_upload;
            window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("editaccount")).show();
        },

        editLaundry(){
            this.laundry.id=this.laundrydetails.id;
            this.laundry.name=this.laundrydetails.name;
            this.laundry.address=this.laundrydetails.address;
            this.laundry.contact=this.laundrydetails.contact;
            this.laundry.footermessage=this.laundrydetails.footermessage;
            this.laundry.file=this.laundrydetails.img;
            window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("location")).show();
        },
       
          async getProfile() {
              this.loading = true;
              this.error = null;
        
              try {
                 var self=this;
                  axios.post("getprofiledetails").then((response) => {
                     self.profiledetails=response.data.allprofiledetails;
                     self.laundrydetails=response.data.getlaundrydetails;
              
                }).then(() => {
                     self.initializeHomeContent();
                }).catch((err) => {
                  
                });;
               
      
              } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
              } finally {
                this.loading = false;
              }
            }, 
      
      
      
      
      
            updateprofile() {
              this.loading = true;
              this.error = null;
        
              try {
                 var self=this;
                  axios.post("updateprofile",self.profile).then((response) => {
                           self.$swal.fire(response.data.message);
                           self.profiledetails=response.data.allprofiledetails;
                           self.laundrydetails=response.data.getlaundrydetails;
                           // if(response.data.success)
                           // {
                           //    self.branch={ name:'',         address:'',contact:'',};
                           // }
                           window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("editaccount")).hide();
                            
      
                     
              
                }).then(() => {
                     self.initializeHomeContent();
                }).catch((err) => {
                  
                });;
               
      
              } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
              } finally {
                this.loading = false;
              }
            }, 
            updatelaundry() {
              this.loading = true;
              this.error = null;
        
              try {
                 var self=this;
                  axios.post("updatelaundrydetails",self.laundry,{
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }).then((response) => {
                                self.$swal.fire(response.data.message);
                               self.profiledetails=response.data.allprofiledetails;
                               self.laundrydetails=response.data.getlaundrydetails;
                           // if(response.data.success)
                           // {
                           //    self.branch={ name:'',         address:'',contact:'',};
                           // }
                           window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("location")).hide();
                            
      
                     
              
                }).then(() => {
                     self.initializeHomeContent();
                }).catch((err) => {
                  
                });;
               
      
              } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
              } finally {
                this.loading = false;
              }
            }, 
      
            editBranch(editBranch) {
               window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
               this.branch=editBranch;
            }, 
      
      
      
      
      
            deleteBranch(id = "") {
          this.loading = true;
          this.error = null;
      
          try {
              var self = this;
      
              this.$swal.fire({
                  title: "Are you sure?",
                  text: "You won't be able to revert this!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#d33",
                  cancelButtonColor: "#3085d6",
                  confirmButtonText: "Yes, delete it!",
                  cancelButtonText: "No, cancel",
              }).then((result) => {
                  if (result.isConfirmed) {
                      axios.post("deletebranch", { id: id }).then((response) => {
                          self.branches = response.data.branches;
                          self.$swal.fire(response.data.message);
                          
                          if (response.data.success) {
                              window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                          }
                      }).then(() => {
                          self.initializeHomeContent();
                      }).catch((err) => {
                          self.$swal.fire("Error!", "Something went wrong.", "error");
                      });
                  }
              });
      
          } catch (err) {
              this.error = err.response?.data?.message || "Login failed. Please try again.";
          } finally {
              this.loading = false;
          }
      },
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
        }
      }
      
      
      
      
      
      
      </script>